import React from 'react';
import './style.scss';
const HeaderTop = (props) => {
  return (
    <div className={props.className}>
      <div className='container'>
        <div className='headerTopMainWrapper'>
          <div className='row'>
            <div className='col-md-3 col-sm-12 col-12 col-lg-5'>
              <ul className='d-flex accountLoginArea'>
                <li>
                  <i className='fa fa-map-marker' aria-hidden='true'></i>2620
                  Mary Hill Road, Port Coquitlam, BC
                </li>
              </ul>
            </div>
            <div className='col-md-6 col-sm-12 col-12 col-lg-5'>
              <ul className='headerContact'>
                <li>
                  <a href='tel:6049272155'>
                    <i className='fa fa-phone'></i> 604.927.2155
                  </a>
                </li>
                <li>
                  <a href='mailto:adam@fritzlerlaw.ca'>
                    <i className='fa fa-envelope'></i> adam@fritzlerlaw.ca
                  </a>
                </li>
              </ul>
            </div>
            <div className='col-lg-2 col-md-3 col-sm-12'>
              <div className='btnStyle btnStyle2 text-right'>
                <a href='contact'>Contact Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HeaderTop;
